export enum EntityType {
  CONVERSATION = "CONVERSATION",
  CLIENT = "CLIENT",
  DELIVERABLE = "DELIVERABLE",
  DELIVERABLE_TEMPLATE = "DELIVERABLE_TEMPLATE"
}

export enum PermissionLevel {
  READ = "READ",
  WRITE = "WRITE"
} 